import { paths } from "helpers/paths";
import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/counterpartyGroups";
import List from "./list";
import Show from "./show";

const CounterpartyGroups = (props) => {
    useEffect(() => {
        return () => props.clearParams("counterparty-groups");
    }, []);

    const { match, location, history } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);

    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={`${rootUrl}/:id`}
                    render={(rest) => (
                        <Show {...rest} transition="full" title="Группа контрагентов" back={back} source={source} />
                    )}
                />
                <Route
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            nofilter
                            transition="full"
                            title="Список групп"
                            back={() => history.push(paths.cargoOwners)}
                        />
                    )}
                />
            </Switch>
        </div>
    );
};

export default CounterpartyGroups;
